import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'STORIES_UPDATE',
    smsDelete : 'STORIES_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        stories: [],
        submitSuccess: false,
        storiesLoading: false,
        storiesError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_STORIES(state, results) {
            state.stories = results;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        STORIES_LOADING (state, loading) {
            state.storiesLoading = loading;
        },

        STORIES_ERROR (state, hasError) {
            state.storiesError = hasError;
        }
    },

    actions: {
        async addStories ({commit, dispatch}, payload) {
            commit('STORIES_LOADING', true);
            commit('STORIES_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_story, payload.item, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchStories')
                return response

            } catch (e) {
                commit('STORIES_ERROR', true);
            } finally {
                commit('STORIES_LOADING', false);
            }
        },

        async fetchStories ({ commit }) {
            commit('STORIES_LOADING', true);
            commit('STORIES_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.story_list, config);
                let response = result.data.data
                commit('SET_STORIES', response);
                return result
            } catch(error) {
                commit('STORIES_ERROR', true);
            } finally {
                commit('STORIES_LOADING', false);
            }
        },

        async updateStories ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_story + payload.id, payload.item, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchStories')
                return response

            } catch (e) {
                commit('STORIES_ERROR', true);
            } finally {
                commit('STORIES_LOADING', false);
            }
        },

        async deleteStories({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.story_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchStories')
            return response
        }
    },

    getters: {}
}
